import { render, staticRenderFns } from "./button-attach.vue?vue&type=template&id=609e3928&"
import script from "./button-attach.vue?vue&type=script&lang=ts&"
export * from "./button-attach.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports